import styled from 'styled-components';

const ContentWrapper = styled.div<{ flexFlow: string, justifyContent: string, alignItems: string }>`
    display: flex;
    flex-flow: ${(props) => props.flexFlow};
    justify-content: ${(props) => props.justifyContent};
    align-items: ${(props) => props.alignItems};
`
interface CardBodyProps {
    className: string,
    flexFlow: string,
    justifyContent: string,
    alignItems: string,
    customCSS: any
}

const CardBody: React.FC<CardBodyProps> = (props) => {
    const { className, children, flexFlow, justifyContent, alignItems, customCSS } = props
    return (
        <>
            <ContentWrapper style={customCSS} justifyContent={justifyContent} alignItems={alignItems} flexFlow={flexFlow} className={className}>
                {children}
            </ContentWrapper>
        </>
    );
};

export default CardBody;
